import { render, staticRenderFns } from "./ApoliceSeguroIBPAdicionar.vue?vue&type=template&id=e058f23a"
import script from "./ApoliceSeguroIBPAdicionar.vue?vue&type=script&lang=js"
export * from "./ApoliceSeguroIBPAdicionar.vue?vue&type=script&lang=js"
import style0 from "./ApoliceSeguroIBPAdicionar.vue?vue&type=style&index=0&id=e058f23a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports